import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'How do I receive the product?',
  answer: 'Access is sent directly to your email immediately after purchase. You can download it on any device.'
}, {
  question: "I don't have enough room in my freezer!",
  answer: 'I prep a whole month using just the freezer attached to my regular fridge. It takes way less space than you\'d think thanks to our "flat-pack" technique.'
}, {
  question: 'I have food intolerances.',
  answer: 'As a health-conscious mom, I take this seriously. All guides include dairy-free and gluten-free alternatives.'
}, {
  question: 'Why does this taste better than other freezer meals?',
  answer: 'Because of the Layered Freshness Shield. By organizing the ingredients in the correct order, we prevent flavors from bleeding together and stop the "freezer burn" from ruining the texture. They taste fresh because they are being cooked for the first time in your home.'
}, {
  question: 'Is there a guarantee?',
  answer: "Yes! I offer a 30-day money-back guarantee. If you don't love it, I'll refund your money."
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-gray-50 px-4 py-10 md:py-20 lg:px-8" data-id="element-72">
      <div className="mx-auto max-w-3xl" data-id="element-73">
        <h2 className="mb-12 text-center font-serif text-3xl font-bold text-text-dark md:text-4xl" data-id="element-74">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-75">
          {faqs.map((faq, index) => <div key={index} className="overflow-hidden rounded-xl bg-white shadow-sm transition-shadow hover:shadow-md" data-id="element-76">
              <button onClick={() => toggleFAQ(index)} className="flex w-full items-center justify-between p-6 text-left focus:outline-none" data-id="element-77">
                <span className="text-lg font-bold text-text-dark" data-id="element-78">
                  {faq.question}
                </span>
                <ChevronDown className={`h-5 w-5 text-terracotta transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-79" />
              </button>

              <AnimatePresence data-id="element-80">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-81">
                    <div className="border-t border-gray-100 px-6 pb-6 pt-2 text-text-dark/80" data-id="element-82">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};